/**
 * FreeFic 品牌 - Tags 页面配置
 */
import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'

/**
 * FreeFic 品牌特定主题配置
 */
export const theme = {
  popupTagBgColor: '#EFF3FA',
  popupTagColor: '#65686F',
  popupTagActiveColor: '#FFFFFF',

  filterBgColor: '#EFF3FA',
  filterActiveBgColor: '#FFF7EF',
  filterColor: '#65686F',
  filterActiveColor: '#E65F3D',
} as const

export const tagsConfig: TagsPageConfig = {
  theme,
  texts: tagsCommonConfig.texts,
}
